export default __webpack_public_path__ + "static/media/PN.54cde341.svg";